<template>
  <div class="text-center py-8">
    <svg
      class="mx-auto h-12 w-12 text-gray-400 dark:text-gray-500"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    <h3 class="mt-2 text-sm font-medium text-gray-900 dark:text-gray-100">
      Sin direcciones
    </h3>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Este cliente no tiene direcciones guardadas
    </p>
  </div>
</template>

<script setup lang="ts">
// No props or logic needed for this component
</script>
